import themeSelector from '@ui-kit/dev-utils/theme-selector/theme-selector.vue';
import themeSelectorCmds from '@ui-kit/dev-utils/theme-selector/theme-selector-cmds';

export default {
  component: themeSelector,
  commands: themeSelectorCmds,
};
